export default __webpack_public_path__ + "static/media/deliver-product.d03335d6.mp4";